var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2474 24C5.30398 24 0 18.864 0 12C0 5.232 5.25577 0 11.9581 0C18.3711 0 23 4.848 23 11.472C23 12.24 22.9036 13.008 22.7107 13.968H5.44864C6.22013 17.136 8.72746 19.056 12.1992 19.056C14.5618 19.056 16.6834 18.24 18.0818 16.608L21.457 20.016C19.1908 22.656 15.8637 24 12.2474 24ZM11.8616 4.848C8.58281 4.848 6.22013 6.672 5.44864 9.648H17.7925C17.1174 6.576 15.0922 4.848 11.8616 4.848Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEWhite);
export default __webpack_public_path__ + "static/media/EWhite.eb767be3ebcdd49eb42cc7755dda49d2.svg";
export { ForwardRef as ReactComponent };